import { AppRoutingConstants } from "../../app-routing.constants";
export class FeatureSearchRoutingConstants {
    static FEATURE_SEARCH_ROUTE = AppRoutingConstants.createRouteToView("feature-search");
}
